import { Select } from '@bloomfieldrobotics/canopy';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { useTranslation } from '../../../services/translation/hooks/useTranslation';
import {
  EndpointEnum,
  endpointOptions,
  selectEndpoint,
  setEndpoint,
} from '../apiExplorerSlice';

const EndpointDropdown: React.FC = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const value = useAppSelector<EndpointEnum>(selectEndpoint);

  const handleChange = (value: EndpointEnum) => {
    dispatch(setEndpoint(value));
  };

  return (
    <Select<EndpointEnum>
      options={endpointOptions}
      value={value}
      onChange={handleChange}
      label={t('Endpoint')}
    />
  );
};

export default EndpointDropdown;
